import { Injectable } from '@angular/core';
import { DateHelper } from '../shared/helpers/date-helper';
import { UserConfirmService } from './user-confirm.service';
import { EasyFormService } from './easy-form-service';
import { EasyNotificationService } from './easy-notification.service';

@Injectable({
  providedIn: 'root'
})
export class CheckDateRegionServiceService {

  constructor(private userconfirm: UserConfirmService,
    private ezForm: EasyFormService,
    private notify: EasyNotificationService) { }
  async Check(sDate:Date,eDate:Date,waringOver = 30,confirmOver = 180,blockOver = 367){
    
    var dateDiff = DateHelper.dayDiff(eDate, sDate);
    if(dateDiff<0){
      this.notify.showWarning('起始日期不能晚於結束日期');
      return false;
    }
    if (dateDiff >= blockOver) {
        await this.userconfirm.showAlert('查詢區間過大', `區間查詢僅限一年以下的條件`)
        return false;
    } else if (dateDiff >= confirmOver && dateDiff < blockOver) {
        var ret = await this.ezForm.show({
            title: '查詢區間較大',
            msg: `查詢超過${confirmOver}天以上的資料會需要相當的等候時間，Are you sure?`,
            fields: {
                sure: {
                    name: 'sure',
                    type: 'text',
                    label: '請輸入sure後繼續',
                    value: '',
                }
            },
            closeValue: () => null
        })
        if (ret?.sure?.toLocaleLowerCase() !== 'sure') { //輸入了sure以後才可以繼續 不分大小寫
            return false;
        }
    } else if (dateDiff >= waringOver && dateDiff < confirmOver) {
        await this.notify.showWarning(`查詢區間偏大，這可能需要一點時間`)
    }
    return true;
  }
}
